export const language: any ={
    cancel: "ยกเลิก",
    ok: "ตกลง",
}
